const urlParams = (
  url,
  params = {}
) => {
  if (!url) return url;

  const newUrl = new URL(url);

  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return;
    newUrl.searchParams.set(key, value);
  });

  return newUrl.href;
};

export default urlParams;
